import './Design/index';

import React from 'react';

import { ThemeProvider } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SnackbarProvider } from 'notistack';
import CacheBuster from 'react-cache-buster';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import packageInfo from '../package.json';
import App from './App/Component/AppFunctional';
import { ResponsiveProvider } from './RiverusUI/Components/ResponsiveProvider';
import SnackbarCloseButton from './RiverusUI/Components/SnakbarCloseButton';
import theme from './RiverusUI/Theme/theme';
import * as serviceWorker from './serviceWorker';
import { store } from './store';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <CacheBuster currentVersion={packageInfo.version}>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <ResponsiveProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <SnackbarProvider
                maxSnack={5}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                action={(snackbarKey) => (
                  <SnackbarCloseButton snackbarKey={snackbarKey} />
                )}
              >
                <App />
              </SnackbarProvider>
            </LocalizationProvider>
          </ResponsiveProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </Provider>
  </CacheBuster>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
